import { createContext, useContext, useReducer, useEffect } from "react";
import { useProductContext } from "./productContext";
import reducer from "../reducer/filterReducer";

const FilterContext = createContext();

const initialState = {
    filter_products: [],
    all_products: [],
    // grid_view: true,
    filters: {
        shape: "all",
        color: "all",
        carat: "all",
        maxPrice: 0,
        price: 0,
        minPrice: 0,
    },
};

export const FilterContextProvider = ({ children }) => {
    const { products } = useProductContext();

    const [state, dispatch] = useReducer(reducer, initialState);

    // update the filter values
    const updateFilterValue = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        console.log(name);

        // if (name === "carat") {
        //     value = event.target.value;
        // }

        return dispatch({ type: "UPDATE_FILTERS_VALUE", payload: { name, value } });
    };

    // to sort the product
    useEffect(() => {
        dispatch({ type: "FILTER_PRODUCTS" });
    }, [products, state.filters]);

    // to load all the products for grid and list view
    useEffect(() => {
        dispatch({ type: "LOAD_FILTER_PRODUCTS", payload: products });
    }, [products]);

    return (
        <FilterContext.Provider
            value={{
                ...state,
                updateFilterValue,
            }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilterContext = () => {
    return useContext(FilterContext);
};